import { listCountries, mapCountries } from "lopermut"
import { useMemo } from "react"
import { useTranslation } from "react-i18next"

export function useCountries() {
  const { i18n } = useTranslation()
  const { language } = i18n

  const labels = useMemo(() => mapCountries(language), [language])
  const countries = useMemo(
    () =>
      listCountries(language).map(({ code, name }) => ({
        label: name,
        value: code,
      })),
    [language],
  )

  return { options: countries, labels }
}
